import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { fmtDateTime } from "./AdminUsersTab";

const BADGE = {
  failed: "text-red-300 border-red-500/40 bg-red-500/10",
  bounced: "text-red-300 border-red-500/40 bg-red-500/10",
  delivered: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  sent: "text-slate-300 border-slate-500/40 bg-slate-500/10",
};

function outcome(e) {
  if (e.status === "failed") return "failed";
  if (e.delivery_status === "delivered") return "delivered";
  if (["bounced", "complained", "failed"].includes(e.delivery_status)) return "bounced";
  return "sent";
}

export default function UserEmailLog({ uid, reloadKey, t }) {
  const { i18n } = useTranslation();
  const fmt = (iso) => fmtDateTime(iso, i18n.language);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get(`/admin/users/${uid}/emails`).then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [uid, reloadKey]);

  if (rows === null) return <div className="text-xs text-slate-500">{t("common.loading")}</div>;
  if (!rows.length) return <div className="text-xs text-slate-500" data-testid="email-log-empty">{t("admin.emailLogEmpty")}</div>;
  return (
    <ul className="space-y-2" data-testid="email-log">
      {rows.map((e) => {
        const s = outcome(e);
        return (
          <li key={e.id} className="text-xs border-l-2 border-slate-700 pl-3" data-testid={`email-log-${e.id}`}>
            <div className="flex items-start justify-between gap-2">
              <span className="text-slate-200 break-words">{e.subject}</span>
              <span className={`shrink-0 text-[10px] label-tech px-1.5 py-0.5 rounded border ${BADGE[s]}`} data-testid={`email-log-status-${e.id}`}>{t(`admin.emailStatus.${s}`)}</span>
            </div>
            <div className="text-slate-500">
              {fmt(e.created_at)} · {e.is_test ? `${t("admin.emailTestTag")} → ` : ""}{e.recipient} · {e.admin_email}
            </div>
            {e.error && <div className="text-red-300 mt-0.5" data-testid={`email-log-error-${e.id}`}>{e.error}</div>}
          </li>
        );
      })}
    </ul>
  );
}
